import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as ordersApi from "../api/ordersApi";
import "./OrderHistory.css";

const OrderConfirmation = () => {
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order || null);
  const [loading, setLoading] = useState(!location.state?.order);
  const [error, setError] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const orderId = searchParams.get("order_id");
    if (!order && orderId) {
      const loadOrder = async () => {
        try {
          const orderFromApi = await ordersApi.getOrderById(orderId);
          setOrder(orderFromApi);
        } catch (err) {
          setError("Unable to load order details.");
        } finally {
          setLoading(false);
        }
      };
      loadOrder();
    } else {
      setLoading(false);
    }
  }, [location.search, order]);

  if (loading) {
    return <div className="order-history__loading">Loading order details...</div>;
  }

  return (
    <div className="order-history__container">
      <div className="order-history__card">
        <div className="order-history__header">
          <div>
            <h1>Order Confirmed</h1>
            <p className="order-history__date">Thank you for your purchase.</p>
          </div>
        </div>

        {error ? (
          <p>{error}</p>
        ) : order ? (
          <div className="order-history__details">
            <div className="order-history__detail-section">
              <h4>Order Number</h4>
              <p>{order.id}</p>
            </div>
            <div className="order-history__detail-section">
              <h4>Order Total (Test)</h4>
              <p>Rs. {order.total}</p>
            </div>
            <div className="order-history__detail-section">
              <h4>Shipping</h4>
              <p>{order.shippingMethod}</p>
            </div>
          </div>
        ) : (
          <p>Your order has been placed successfully. You can view your order history below.</p>
        )}

        <div className="order-history__summary">
          <div className="order-history__summary-row">
            <span>Order Status</span>
            <span className="status-badge status-test-only">Test Order</span>
          </div>
          <div className="order-history__summary-row order-history__summary-total">
            <span>Payment and fulfillment</span>
            <span>No payment was collected. This preview order will not be fulfilled.</span>
          </div>
        </div>

        <div className="order-history__empty-actions" style={{ marginTop: 20 }}>
          <Link to="/order-history" className="btn btn--primary">
            View Order History
          </Link>
          <Link to="/shop" className="btn btn--secondary" style={{ marginLeft: 12 }}>
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
